// URL Utilities for handling redirect parameters and login flow

/**
 * Get redirect parameters from URL
 * @returns {Object} Object containing test, testseries, and other parameters
 */
export const getRedirectParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    test: urlParams.get('test'),
    testseries: urlParams.get('testseries'),
    redirectUrl: urlParams.get('redirect') || '/start'
  };
};

/**
 * Save redirect parameters to localStorage
 * @param {Object} params - Parameters to save
 */
export const saveRedirectParams = (params) => {
  if (params.test || params.testseries) {
    localStorage.setItem('redirectParams', JSON.stringify(params));
  }
};

/**
 * Get saved redirect parameters from localStorage
 * @returns {Object} Saved redirect parameters
 */
export const getSavedRedirectParams = () => {
  const saved = localStorage.getItem('redirectParams');
  const parsed = saved ? JSON.parse(saved) : null;
  return parsed;
};

/**
 * Clear saved redirect parameters
 */
export const clearRedirectParams = () => {
  localStorage.removeItem('redirectParams');
};

/**
 * Build redirect URL with parameters
 * @param {string} baseUrl - Base URL to redirect to
 * @param {Object} params - Parameters to include
 * @returns {string} Complete redirect URL
 */
export const buildRedirectUrl = (baseUrl, params) => {
  const url = new URL(baseUrl, window.location.origin);
  
  if (params.test) {
    url.searchParams.set('test', params.test);
  }
  
  if (params.testseries) {
    url.searchParams.set('testseries', params.testseries);
  }
  
  return url.pathname + url.search;
};

/**
 * Build start page URL with test parameter
 * @param {string} testId - Test ID to include in URL
 * @returns {string} Start page URL with test parameter
 */
export const buildStartPageUrl = (testId) => {
  if (!testId) return '/start';
  return `/start?test=${encodeURIComponent(testId)}`;
};

/**
 * Get test ID from current URL or localStorage
 * @returns {string|null} Test ID if found
 */
export const getCurrentTestId = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlTestId = urlParams.get('test');
  
  if (urlTestId) return urlTestId;
  
  const savedParams = getSavedRedirectParams();
  return savedParams?.test || null;
}; 